/** Значения перечислений из контракта backend'а и их подписи для интерфейса. */

export const CONTENT_STATUSES = [
  { value: "CONTENT_STATUS_DRAFT", label: "Черновик", color: "gold" },
  { value: "CONTENT_STATUS_PUBLISHED", label: "Опубликовано", color: "green" },
  { value: "CONTENT_STATUS_REJECTED", label: "Отклонено", color: "red" },
  { value: "CONTENT_STATUS_ARCHIVED", label: "В архиве", color: "default" },
] as const;

export const QUEST_TYPES = [
  { value: "QUEST_TYPE_DAILY", label: "Квест дня" },
  { value: "QUEST_TYPE_THEMED", label: "Тематический" },
  { value: "QUEST_TYPE_CUSTOM", label: "Пользовательский" },
  { value: "QUEST_TYPE_WORLD", label: "Весь мир" },
] as const;

/** Типы, которые можно выбрать в форме: «Весь мир» один и заводится миграцией. */
export const SELECTABLE_QUEST_TYPES = QUEST_TYPES.filter((item) => item.value !== "QUEST_TYPE_WORLD");

export const ROLES = [
  { value: "ROLE_PLAYER", label: "Игрок", color: "default" },
  { value: "ROLE_MODERATOR", label: "Модератор", color: "blue" },
  { value: "ROLE_ADMIN", label: "Администратор", color: "gold" },
] as const;

export function statusMeta(value?: string) {
  return CONTENT_STATUSES.find((item) => item.value === value);
}

export function questTypeLabel(value?: string): string {
  return QUEST_TYPES.find((item) => item.value === value)?.label ?? "—";
}

export function roleMeta(value?: string) {
  return ROLES.find((item) => item.value === value);
}

/** Год: отрицательные значения — до нашей эры. */
export function formatYear(year?: number): string {
  if (year === undefined || year === null) return "—";
  return year < 0 ? `${Math.abs(year)} до н. э.` : String(year);
}

export function formatCoordinates(latitude?: number, longitude?: number): string {
  if (latitude === undefined || longitude === undefined) return "—";
  return `${latitude.toFixed(4)}, ${longitude.toFixed(4)}`;
}

/**
 * Дата и время сообщения.
 *
 * Модератору важно не только что написали, но и когда: по дате видно, о какой
 * версии игры речь и не устарела ли жалоба.
 */
export function formatDateTime(value?: string): string {
  if (!value) return "—";
  const date = new Date(value);
  return Number.isNaN(date.getTime())
    ? "—"
    : date.toLocaleString("ru-RU", { dateStyle: "short", timeStyle: "short" });
}
